function cartItem(state = [], action) {
  switch (action.type) {
    case 'SET_CART_ITEM_DATA':
      // let newState = state.concat(action.cartItem);
      const newState = action.cartItem;
      return newState;

    default:
      return state;
  }
}

export default cartItem;
